var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "form" },
    [
      _c("vuejs-signup-module", {
        attrs: {
          "form-valid": _vm.userDetailsAreValid,
          countries: _vm.acceptedCountries,
          "form-options": _vm.formOptions,
          "recaptcha-site-key": _vm.recaptchaKey,
          "default-country-code": _vm.defaultCountryCode,
        },
        on: {
          recaptchaVerified: _vm.recaptchaVerificationHandler,
          recaptchaExpired: _vm.recaptchaExpirationHandler,
          submit: _vm.submitSignup,
        },
        scopedSlots: _vm._u([
          {
            key: "signup-form-pre-submit",
            fn: function () {
              return [
                _c(
                  "section",
                  {
                    staticClass: "signup-tcs",
                    attrs: {
                      "data-cy": "user-signup-terms-and-conditions-wrapper",
                    },
                  },
                  [
                    _c(
                      "p",
                      {
                        attrs: {
                          "data-cy": "user-signup-terms-and-conditions-content",
                        },
                      },
                      [
                        _vm._v("\n          By signing up, you agree to our "),
                        _c("router-link", { attrs: { to: _vm.links.terms } }, [
                          _vm._v("Terms and Conditions"),
                        ]),
                        _vm._v(" and "),
                        _c(
                          "router-link",
                          { attrs: { to: _vm.links.privacy } },
                          [_vm._v("Privacy Policy")]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "signup-form-next-to-submit",
            fn: function () {
              return [
                !_vm.signed
                  ? _c(
                      "b-btn",
                      {
                        attrs: { variant: "secondary", small: "" },
                        on: {
                          click: function ($event) {
                            return _vm.$eventHub.$emit("showLoginModal")
                          },
                        },
                      },
                      [_vm._v("Already have an account?")]
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.formValues,
          callback: function ($$v) {
            _vm.formValues = $$v
          },
          expression: "formValues",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }